import "./src/styles/global.css";
import "./src/utils/algolia-insights";

export const shouldUpdateScroll = () => {
  if (typeof window !== "undefined") {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
  return false;
};
export const onClientEntry = () => {
  if (typeof window === "undefined") return;
  if (typeof document === "undefined") return;

  const INACTIVITY_THRESHOLD = 5 * 60 * 1000; // 5 minutes of no activity
  const CHECK_INTERVAL = 60 * 1000; // Check every minute
  const KEEP_ALIVE_INTERVAL = 5 * 60 * 1000; // Send every 5 min while inactive
  let lastActivity = Date.now();
  let hiddenTabTimer = null;
  let hiddenTabInterval = null;

  const sendKeepAlive = () => {
    fetch(window.location.origin, {
      method: "HEAD",
      cache: "no-store",
      keepalive: true,
    }).catch(() => { });
  };

  const updateActivity = () => {
    lastActivity = Date.now();
  };

  const checkInactivity = () => {
    if (document.hidden) return; // Tab in background - visibility handler covers that
    if (Date.now() - lastActivity >= INACTIVITY_THRESHOLD) {
      sendKeepAlive();
      lastActivity = Date.now(); // Space out pings while inactive
    }
  };

  const handleVisibilityChange = () => {
    if (document.hidden) {
      // Tab hidden: send keep-alive after threshold, then every 5 min while hidden
      hiddenTabTimer = setTimeout(() => {
        sendKeepAlive();
        hiddenTabTimer = null;
        hiddenTabInterval = setInterval(sendKeepAlive, KEEP_ALIVE_INTERVAL);
      }, INACTIVITY_THRESHOLD);
    } else {
      if (hiddenTabTimer) {
        clearTimeout(hiddenTabTimer);
        hiddenTabTimer = null;
      }
      if (hiddenTabInterval) {
        clearInterval(hiddenTabInterval);
        hiddenTabInterval = null;
      }
      lastActivity = Date.now(); // User returned - reset activity
    }
  };

  const activityEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart", "click"];
  activityEvents.forEach((ev) => document.addEventListener(ev, updateActivity, { passive: true }));

  document.addEventListener("visibilitychange", handleVisibilityChange);

  // Check every minute: if page visible and inactive for 5+ min, send keep-alive
  setInterval(checkInactivity, CHECK_INTERVAL);

  // Load 3rd-party scripts upon first user interaction to maximize performance
  // and satisfy Lighthouse "Wasted Bytes" for Baseline features.
  const loadThirdPartyScripts = () => {
    if (window.scriptsLoaded) return;
    window.scriptsLoaded = true;

    // 1. Algolia
    if (!window.algoliasearch) {
      const script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/algoliasearch@4/dist/algoliasearch-lite.umd.js";
      script.async = true;
      document.head.appendChild(script);
    }

    const currentPath = window.location.pathname;

    // 2. UserWay (Accessibility Widget)

    if (currentPath.includes("/vid-feedback/")) {
      const existingScript = document.getElementById("userway-widget");
      if (existingScript) {
        existingScript.remove();
      }
      return;
    }
    if (!document.getElementById("userway-widget")) {
      // window.userwayConfig = { position: "3" };
      const s = document.createElement("script");
      s.id = "userway-widget";
      s.src = "https://cdn.userway.org/widget.js";
      s.setAttribute("data-account", "eA6puDtv97");
      s.async = true;
      document.body.appendChild(s);
    }

    // Cleanup listeners
    const interactionEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
    interactionEvents.forEach((ev) => {
      document.removeEventListener(ev, loadThirdPartyScripts);
    });
  };

  const interactionEvents = ["mousedown", "mousemove", "keydown", "scroll", "touchstart"];
  interactionEvents.forEach((ev) => {
    document.addEventListener(ev, loadThirdPartyScripts, { passive: true, once: true });
  });

  // Fallback: If no interaction within 8 seconds, load anyway for accessibility
  setTimeout(loadThirdPartyScripts, 8000);
};
